(ns dre.pages.frontpage.topic-search.templates.risk-prognosis
  (:require
   [dre.i18n.views :refer [tr]]))

(def template
  {:risk-prognosis {:title [tr "Risk/Prognosis"]
                    :form-sub-heading [:<>
                                       [:span [tr "Please add one or more terms for any category."]]
                                       [:span [tr "After clicking “View Results”, you can edit your question and/or search criteria."]]]
                    :forms-type :common
                    :forms [{:title [tr "Risk/Prognosis of"] 
                             :form-id :risk-prognosis
                             :form-type :common
                             :required? false
                             :top-terms-type ["DIS" "O"]
                             :operator :or
                             :examples [{:pill/type :term
                                         :pill/query "SUE-_S"
                                         :pill/label "Mortality"}
                                        {:pill/type :term
                                         :pill/query "SUJY3"
                                         :pill/label "Stroke"}
                                        {:pill/type :term
                                         :pill/query "SUBAB"
                                         :pill/label "Asthma"}
                                        {:pill/type :term
                                         :pill/query "SUElw"
                                         :pill/label "Heart Disease"}]}
                            {:title [tr "Demographics"] 
                             :form-id :demographics
                             :form-type :common
                             :required? false
                             :top-terms-type ["DEM"]
                             :operator :and
                             :examples [{:pill/type :term
                                         :pill/query "SUVI3"
                                         :pill/label "Male"}
                                        {:pill/type :term
                                         :pill/query "SUVEQ"
                                         :pill/label "Female"}
                                        {:pill/type :term
                                         :pill/query "SUcB"
                                         :pill/label "Elderly"}
                                        {:pill/type :term
                                         :pill/query "SUKLo"
                                         :pill/label "United States"}]}
                            {:title [tr "Conditions/Exposures/Biomarkers"] 
                             :form-id :conditions-exposures-biomarkers
                             :form-type :common
                             :required? false
                             :top-terms-type nil
                             :top-terms-hardcoded-fn (fn [search-query-template]
                                                       [{:pill/type :term
                                                         :pill/query "S0FA7"
                                                         :pill/label "Hypertension"}
                                                        {:pill/type :term
                                                         :pill/query "SUJH6"
                                                         :pill/label "Smoking"}
                                                        {:pill/type :term
                                                         :pill/query "SUCRkA"
                                                         :pill/label "BRCA"}
                                                        {:pill/type :term
                                                         :pill/query "SUKDw"
                                                         :pill/label "Troponin"}
                                                        {:pill/type :term
                                                         :pill/query "SUC5I"
                                                         :pill/label "Diabetes"}
                                                        {:pill/type :term
                                                         :pill/query "SUFt7"
                                                         :pill/label "Leukemia"}
                                                        {:pill/type :term
                                                         :pill/query "SUHdn7"
                                                         :pill/label "Coronary Artery Disease"}
                                                        {:pill/type :term
                                                         :pill/query "SUDk1"
                                                         :pill/label "Epstein Barr virus"}
                                                        {:pill/type :term
                                                         :pill/query "SUGNR"
                                                         :pill/label "Mercury"}
                                                        {:pill/type :term
                                                         :pill/query "SUFqI"
                                                         :pill/label "lead"}
                                                        {:pill/type :term
                                                         :pill/query "SUEC1"
                                                         :pill/label "Formaldehyde"}
                                                        {:pill/type :term
                                                         :pill/query "SUCg3"
                                                         :pill/label "Creatinine"}
                                                        {:pill/type :term
                                                         :pill/query "SUds"
                                                         :pill/label "Alanine Transaminase"}
                                                        {:pill/type :term
                                                         :pill/query "SUDmL"
                                                         :pill/label "Hemoglobin"}
                                                        {:pill/type :term
                                                         :pill/query "SUBmh"
                                                         :pill/label "C-reactive protein"}
                                                        {:pill/type :senses
                                                         :pill/query "SUEzma"
                                                         :pill/label "BRAF"
                                                         :pill/other-senses (list "SUDGTS")
                                                         :pill/excluded-senses (list)}])
                             :operator :and
                             :examples [{:pill/type :term
                                         :pill/query "S0FA7"
                                         :pill/label "Hypertension"}
                                        {:pill/type :senses
                                         :pill/query "SUJH6"
                                         :pill/other-senses (list "SUBu1t"),
                                         :pill/excluded-senses (list),
                                         :pill/label "Smoking"}
                                        {:pill/type :term
                                         :pill/query "SUCRkA"
                                         :pill/label "BRCA"}
                                        {:pill/type :term
                                         :pill/query "SUKDw"
                                         :pill/label "Troponin"}]}]
                    :review-query-render-fn (fn [items search-query-template]
                                              [:span.text (str " What is the risk/prognosis of ") (:risk-prognosis items)
                                               " in " (:demographics items) " population(s) with "
                                               (:conditions-exposures-biomarkers items)
                                               "?"])
                    :default-search-query-template :accuracy
                    :search-query-templates {:accuracy {:query/pill
                                                        {:pill/type "boost"
                                                         :pill/pills
                                                         [{:pill/type "and"
                                                           :pill/pills
                                                           [{:pill/type "tag"
                                                             :pill/query "predicted/risk_postfilter"
                                                             :pill/label "Risk/Prognosis"}
                                                            {:template-type :risk-prognosis
                                                             :pill/type "sentence-tag"
                                                             :pill/query "title-or-keywords"}
                                                            {:template-type :demographics
                                                             :pill/type "sentence-tag"
                                                             :pill/query "title-or-abstract-or-keywords"}
                                                            {:template-type :conditions-exposures-biomarkers
                                                             :pill/type "sentence-tag"
                                                             :pill/query "title-or-abstract-or-keywords"}]}
                                                          {:template-type :risk-prognosis
                                                           :pill/type "sentence-tag"
                                                           :pill/query "title"}
                                                          {:template-type :conditions-exposures-biomarkers
                                                           :pill/type "sentence-tag"
                                                           :pill/query "title"}
                                                          {:template-type :demographics
                                                           :pill/type "sentence-tag"
                                                           :pill/query "title"}]}
                                                        :response/filter
                                                        {:search/count true :search/count-1w true :search/count-6m true}}}}})